import * as moment from "moment";

const baseUrl =
    process.env.REACT_APP_API_BASEURL ||
    `http://localhost:${process.env.REACT_APP_PORT}`;
const bucketUrl = "https://sopia.ams3.digitaloceanspaces.com/production";

export { baseUrl, bucketUrl };

export const requestState = {
    none: "NONE",
    inProgress: "IN_PROGRESS",
    ok: "OK",
    fail: "FAIL",
};

export const stringToDate = dateString => {
    if (!dateString) return undefined;
    return moment(dateString);
};

export const prettyDates = {
    day: string => (string ? moment(string).format("DD/MM/YYYY") : "-"),
    month: string => (string ? moment(string).format("MMMM YYYY") : "-"),
    year: string => (string ? moment(string).format("YYYY") : "-"),
};

export const dateFormat = date => {
    if (!date) return undefined;
    return date.toISOString();
};

export const auth = getState => ({
    headers: {
        bearer: getState().user.bearerToken,
    },
});

export const objectToArray = obj => {
    const result = [];
    for (var key in obj) {
        result.push(obj[key]);
    }
    return result;
};

export const capitalize = str =>
    str ? str[0].length >1 ? capitalize(str[0]):`${str[0].toUpperCase()}${str.slice(1)}`: "";

/** Transforms `UPPER_SNAKE_CASE` string into `Upper snake case` */
export const prettyConstant = str =>
    capitalize((str || "").toLowerCase().replace(/_/g, " "));

/** Transforms `lowerCamelCase` string into `Lower camel case` */
export const prettyCamelCase = str => {
    let result = [];
    let cursor = 0;
    for (const match of str.matchAll(/[a-z][A-Z0-9]/g)) {
        const index = match.index;
        result.push(str.substring(cursor, index + 1));
        result.push(" ");
        result.push(str.substring(index + 1, index + 2).toLowerCase());
        cursor = index + 2;
    }
    result.push(str.substring(cursor));
    return capitalize(result.join(""));
};

/** Convert an array into form-compatible object
 * E.g.
 *	`["BOTTOM", "MIDDLE"]` => `{BOTTOM: true, MIDDLE: true}`
 *	`[2, 3, 4]` => `{"2": true, "3": true, "4": true}`
 * */
export const initialArrayToObject = (values, key) => {
    if (Array.isArray(values[key])) {
        const result = {};
        values[key].forEach(value => (result[value] = true));
        return { [key]: result };
    }
    return {};
};

export const initialLocation = (values, key) => {
    if (
        values[key] &&
        typeof values[key].x === "number" &&
        typeof values[key].y === "number"
    ) {
        return { [key]: { lat: values[key].x, lng: values[key].y } };
    }
    return {};
};

/** Convert a form-compatible object into a string array
 * E.g.
 *	`{BOTTOM: true, MIDDLE: true}` => `["BOTTOM", "MIDDLE"]`
 *	`{"2": true, "3": false, "4": true}` => `["2", "4"]`
 * */
export const translateObjectToStringArray = (values, key) => {
    if (
        values[key] &&
        typeof values[key] === "object" &&
        !Array.isArray(values[key])
    ) {
        const result = [];
        Object.entries(values[key])
            .filter(([_, v]) => v === true)
            .forEach(([k, _]) => result.push(k));
        return { [key]: result };
    }
    return {};
};

/** Convert a form-compatible object into a string array
 * E.g.
 *	`{BOTTOM: true, MIDDLE: true}` => `[]`
 *	`{"2": true, "3": false, "4": true}` => `[2, 4]`
 * */
export const translateObjectToNumberArray = (values, key) => {
    if (!values[key]) {
        return {};
    }
    const isSparseBoolSet =
        Array.isArray(values[key]) &&
        values[key].every(value => [null, false, true].includes(value));
    const isObjectSet =
        typeof values[key] === "object" && !Array.isArray(values[key]);
    if (isSparseBoolSet || isObjectSet) {
        const result = [];
        Object.entries(values[key]).forEach(([k, v]) => {
            if (v !== true) return;
            const numeral = Number(k);
            if (!Number.isNaN(numeral)) result.push(k);
        });
        return { [key]: result };
    }
    return {};
};

export const translateLocation = location => {
    if (!location || location.lat === undefined || location.lng === undefined)
        return {};
    return {
        location: { x: location.lat, y: location.lng },
    };
};
